import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AggregatedInstallierteLeistungByAnlagentypComponent } from './report/aggregated-installierte-leistung-by-anlagentyp/aggregated-installierte-leistung-by-anlagentyp.component';
import { MaterialModule } from '../common/material/material.module';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from '../app-routing.module';
import { DashboardPageComponent } from './dashboard-page/dashboard-page.component';
import { AggregatedInstallierteLeistungByEnergieartComponent } from './report/aggregated-installierte-leistung-by-energieart/aggregated-installierte-leistung-by-energieart.component';
import { AggregationTileComponent } from './report/aggregation-tile/aggregation-tile.component';
import { SimpleBarsComponent } from './report/simple-bars/simple-bars.component';
import { NotifyDatenabfrageComponent } from './notify-datenabfrage/notify-datenabfrage.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PipeModule } from '../common/pipe/pipe.module';
import { DashboardUuidChangeConfirmationComponent } from './dashboard-uuid-change-confirmation/dashboard-uuid-change-confirmation.component';
import { DashboardNetzzuordnungenComponent } from './dashboard-netzzuordnungen/dashboard-netzzuordnungen.component';
import { DashboardInfoBoxComponent } from './dashboard-info-box/dashboard-info-box.component';
import { UptodateConfirmationComponent } from './uptodate-confirmation/uptodate-confirmation.component';
import {
    NetzzuordnungImportReportComponent,
} from './dashboard-netzzuordnungen-import/netzzuordnung-import-report/netzzuordnung-import-report.component';

@NgModule({
    declarations: [
        AggregatedInstallierteLeistungByAnlagentypComponent,
        DashboardPageComponent,
        DashboardNetzzuordnungenComponent,
        AggregatedInstallierteLeistungByEnergieartComponent,
        AggregationTileComponent,
        SimpleBarsComponent,
        NotifyDatenabfrageComponent,
        DashboardUuidChangeConfirmationComponent,
        DashboardInfoBoxComponent,
        UptodateConfirmationComponent,
    ],
    imports: [
        CommonModule,
        BrowserModule,
        AppRoutingModule,
        MaterialModule,
        FormsModule,
        ReactiveFormsModule,
        PipeModule,
        NetzzuordnungImportReportComponent,
    ],
})
export class DashboardModule {
}
